import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon, FacebookIcon, ExternalLinkIcon } from 'lucide-react';
export const Footer = () => {
  const scrollToSection = sectionId => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-gray-800 text-white pt-16 pb-8" data-id="element-172">
      <div className="container mx-auto px-4" data-id="element-173">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12" data-id="element-174">
          <div className="md:col-span-1" data-id="element-175">
            <h3 className="text-2xl font-bold mb-6 text-blue-300" data-id="element-176">
              AIR-MAZING AIR, INC.
            </h3>
            <p className="mb-6 text-gray-300 leading-relaxed" data-id="element-177">
              Over 10 years of providing high-quality HVAC installation, repair,
              and maintenance services to residential and commercial customers.
            </p>
            <div className="flex flex-col space-y-4" data-id="element-178">
              <a href="https://www.facebook.com/airmazingairhvac" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white px-5 py-3 rounded-md font-medium transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-179">
                <FacebookIcon className="mr-2 h-5 w-5" data-id="element-180" />
                Follow us on Facebook
              </a>
              <div className="flex space-x-5 mt-4" data-id="element-181">
                <a href="https://www.facebook.com/airmazingairhvac" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-blue-400 transition-colors" aria-label="Facebook" data-id="element-182">
                  <FacebookIcon size={24} data-id="element-183" />
                </a>
                <a href="https://www.thumbtack.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-blue-400 transition-colors" aria-label="Thumbtack" data-id="element-184">
                  <ExternalLinkIcon size={24} data-id="element-185" />
                </a>
                <a href="https://www.nextdoor.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-blue-400 transition-colors" aria-label="Nextdoor" data-id="element-186">
                  <ExternalLinkIcon size={24} data-id="element-187" />
                </a>
              </div>
            </div>
          </div>
          <div data-id="element-188">
            <h3 className="text-xl font-bold mb-6 text-blue-300" data-id="element-189">
              Our Services
            </h3>
            <ul className="space-y-3" data-id="element-190">
              <li data-id="element-191">
                <Link to="/#residential-install" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center" data-id="element-192">
                  <span className="text-blue-400 mr-2" data-id="element-193">›</span>
                  New AC Installations
                </Link>
              </li>
              <li data-id="element-194">
                <Link to="/#emergency-service" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center" data-id="element-195">
                  <span className="text-blue-400 mr-2" data-id="element-196">›</span>
                  24-Hour Emergency Repairs
                </Link>
              </li>
              <li data-id="element-197">
                <Link to="/#air-quality" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center" data-id="element-198">
                  <span className="text-blue-400 mr-2" data-id="element-199">›</span>
                  Air Quality & Duct Cleaning
                </Link>
              </li>
              <li data-id="element-200">
                <Link to="/#insulation" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center" data-id="element-201">
                  <span className="text-blue-400 mr-2" data-id="element-202">›</span>
                  Home Insulation Services
                </Link>
              </li>
              <li data-id="element-203">
                <Link to="/#commercial" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center" data-id="element-204">
                  <span className="text-blue-400 mr-2" data-id="element-205">›</span>
                  Commercial AC Solutions
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-206">
            <h3 className="text-xl font-bold mb-6 text-blue-300" data-id="element-207">Resources</h3>
            <ul className="space-y-3" data-id="element-208">
              <li data-id="element-209">
                <Link to="/#faq" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center" data-id="element-210">
                  <span className="text-blue-400 mr-2" data-id="element-211">›</span>
                  FAQ
                </Link>
              </li>
              <li data-id="element-212">
                <Link to="/#about" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center" data-id="element-213">
                  <span className="text-blue-400 mr-2" data-id="element-214">›</span>
                  About Us
                </Link>
              </li>
              <li data-id="element-215">
                <Link to="/#testimonials" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center" data-id="element-216">
                  <span className="text-blue-400 mr-2" data-id="element-217">›</span>
                  Testimonials
                </Link>
              </li>
              <li data-id="element-218">
                <Link to="/blog" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center" data-id="element-219">
                  <span className="text-blue-400 mr-2" data-id="element-220">›</span>
                  Blog
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-221">
            <h3 className="text-xl font-bold mb-6 text-blue-300" data-id="element-222">Contact Us</h3>
            <ul className="space-y-4" data-id="element-223">
              <li className="flex items-center" data-id="element-224">
                <PhoneIcon className="h-5 w-5 mr-3 text-blue-400" data-id="element-225" />
                <a href="tel:2398886268" className="text-gray-300 hover:text-blue-400 transition-colors" data-id="element-226">
                  239-888-6268
                </a>
              </li>
              <li className="flex items-center" data-id="element-227">
                <MailIcon className="h-5 w-5 mr-3 text-blue-400" data-id="element-228" />
                <a href="mailto:info@airmazingair.com" className="text-gray-300 hover:text-blue-400 transition-colors" data-id="element-229">
                  info@airmazingair.com
                </a>
              </li>
              <li className="flex items-start" data-id="element-230">
                <MapPinIcon className="h-5 w-5 mr-3 text-blue-400 mt-1" data-id="element-231" />
                <span className="text-gray-300" data-id="element-232">
                  Serving all of Southwest Florida
                </span>
              </li>
            </ul>
            <div className="mt-8" data-id="element-233">
              <button onClick={() => scrollToSection('#request-service')} className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-all duration-300 shadow-md hover:shadow-lg cursor-pointer" data-id="element-234">
                Request Service
              </button>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-8 text-center text-sm text-gray-400" data-id="element-235">
          <p data-id="element-236">
            &copy; {new Date().getFullYear()} AIR-MAZING AIR, INC. All rights
            reserved.
          </p>
          <p className="mt-2" data-id="element-237">Licensed & Insured HVAC Contractor</p>
        </div>
      </div>
    </footer>;
};